import script from "./DsnNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./DsnNavbar.vue?vue&type=script&setup=true&lang=js"

import "./DsnNavbar.vue?vue&type=style&index=0&id=7b03bcea&lang=scss"

const __exports__ = script;

export default __exports__